<template>
  <div class="skeleton overview">
    <div class="overview__left">
      <div class="overview__left-top">
        <div class="skeleton__box overview__title">
          <p class="skeleton__content skeleton__animate--white"></p>
          <h4 class="skeleton__title skeleton__animate--white"></h4>
        </div>
        <div class="skeleton__box overview__desc">
          <p class="skeleton__content skeleton__animate--white"></p>
          <p class="skeleton__content skeleton__animate--white"></p>
          <p class="skeleton__content skeleton__animate--white"></p>
          <p class="skeleton__content skeleton__animate--white"></p>
          <p class="skeleton__content skeleton__animate--white"></p>
          <p class="skeleton__content skeleton__animate--white"></p>
        </div>
      </div>
      <div class="overview__left-bottom">
        <figure class="skeleton__animate overview__bar"></figure>
        <figure class="skeleton__animate skeleton__btn overview__btn"></figure>
      </div>
    </div>
    <div class="overview__right">
      <p class="skeleton__animate--white skeleton__content"></p>
      <p class="skeleton__animate--white skeleton__content"></p>
      <div class="overview__profiles">
        <figure
          class="skeleton__animate--white overview__main-profile"
        ></figure>
        <figure class="skeleton__animate--white overview__profile"></figure>
        <figure class="skeleton__animate--white overview__profile"></figure>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PathOverviewSkel',
}
</script>

<style lang="scss" scoped>
.overview {
  display: flex;
  flex-wrap: wrap;
  padding: 75px 25px;
  @include tablet {
    padding: 50px 100px;
    flex-wrap: nowrap;
  }
  &__left {
    width: 100%;
    padding-right: 0;
    @include mobile {
      padding-right: 50px;
    }
    @include desktop {
      width: 60%;
      padding-right: 100px;
    }
  }
  &__left-bottom {
    margin: 5rem 0 0 -2rem;
  }
  &__bar {
    height: 5px;
    width: 90%;
  }
  &__btn {
    width: 150px;
  }
  &__right {
    width: 100%;
    padding-top: 25px;
    @include tablet {
      padding-top: 50px;
      flex-grow: 1;
    }
    @include desktop {
      width: 40%;
    }
  }
  &__profiles {
    display: flex;
    width: 100%;
    justify-content: flex-start;
  }
  &__main-profile {
    border-radius: 100%;
    border: 1px solid var(--orange);
    width: 100px;
    height: 100px;
    margin: 0 5px 0 0;
  }
  &__profile {
    border-radius: 100%;
    width: 75px;
    height: 75px;
    margin: 10px 0 0 5px;
  }
}
</style>
